module.exports = __webpack_public_path__ + "img/1_1-residenziale-villette_singole-2.1a8bec7b.png";